var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacateHouseCerti1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8402 59.9019C29.2998 59.8504 28.7618 59.778 28.2275 59.6848C27.835 59.6166 27.4681 59.4494 27.1635 59.2C26.8589 58.9506 26.6275 58.6278 26.4925 58.2642C26.3575 57.9005 26.3238 57.5088 26.3946 57.1284C26.4655 56.7481 26.6385 56.3925 26.8962 56.0976C28.1375 54.679 28.9852 52.977 29.3591 51.1524C29.4287 50.8151 29.2925 50.2226 28.5906 49.5597C23.5983 44.8521 20.5 38.4667 20.5 31.3979C20.5 16.6444 33.8975 5 50 5C66.1025 5 79.5 16.6444 79.5 31.3979C79.5 46.1515 66.1025 57.7959 50 57.7959C47.4796 57.7959 45.0289 57.5114 42.687 56.9775C38.8591 59.3096 34.3387 60.3386 29.8402 59.9019Z",
    fill: "#2B374E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2771 17.2956C49.6787 16.9015 50.3213 16.9015 50.7229 17.2956L65.188 31.4931C65.8488 32.1417 65.3903 33.2664 64.4651 33.2664H35.5349C34.6097 33.2664 34.1512 32.1417 34.812 31.4931L49.2771 17.2956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1552 29.5179C39.1552 28.9466 39.6176 28.4835 40.188 28.4835H59.8118C60.3822 28.4835 60.8446 28.9466 60.8446 29.5179V42.9656C60.8446 43.5369 60.3822 44 59.8118 44H40.188C39.6176 44 39.1552 43.5369 39.1552 42.9656V29.5179Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 28,
    width: 14.1146,
    height: 1.76119,
    transform: "rotate(45 45 28)",
    fill: "#2B374E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 29,
    width: 14.1146,
    height: 1.76119,
    transform: "rotate(135 55 29)",
    fill: "#2B374E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacateHouseCerti1);
export default __webpack_public_path__ + "static/media/VacateHouseCerti1.83fafe7063005546f58a1df194812d7d.svg";
export { ForwardRef as ReactComponent };